import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  deptBydomain,
  desigByDept,
  desigByDomain,
} from "../Services/getServices";
import { ssoRoleBydomain } from "../Services/getServices";
import { ssoRoleBydept } from "../Services/getServices";
import SideBar from "./SideBar";
import { loader } from "../redux/type";
import { registerNewUser } from "../Services/getServices";
import { pincodeList } from "../Services/getServices";
import { localityList } from "../Services/getServices";
import { districtList } from "../Services/getServices";
import { domainList } from "../Services/getServices";
import { LoginUser } from "../Services/authServices";
import { toast } from "react-toastify";
import Aawaas from "./DomainPages/Aawas";
import OnlineMeasurementEMB from "./DomainPages/OnlineMeasurementEMB";
import CitizensCentric from "./DomainPages/CitizensCentric";
import Idli from "./DomainPages/Idli";
import WaterBill from "./DomainPages/WaterBill";
import OnlineBookingCommunity from "./DomainPages/OnlineBookingCommunity";
import Bhoomi from "./DomainPages/Bhoomi"
import Opd from "./DomainPages/Opd";
const DeptMyProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const mobNum = localStorage.getItem("moblie");

  var [tit, setTit] = useState("");
  var [firstName, setFirstName] = useState("");
  var [middleName, setMiddleName] = useState("");
  var [lastName, setLastName] = useState("");
  var [fatherName, setFatherName] = useState("");
  var [aadhaarNo, setAadhaarNo] = useState("");
  var [mobileNo, setMobileNo] = useState("");
  var [panNo, setPanNo] = useState("");
  var [email, setEmail] = useState("");
  var [gender, setGender] = useState("");
  var [dob, setDob] = useState("");
  var [consumerId, setConsumerId] = useState("");
  var [property, setProperty] = useState("");
  var [createUser, setCreateUser] = useState("");
  var [password, setPassword] = useState("");
  var [pincode, setPincode] = useState("");
  var [district, setDistrict] = useState("");
  var [locality, setLocality] = useState("");

  var [domainListArr, setDomainListArr] = useState([]);
  var [domainCodeS, setDomainCodeS] = useState("");

  useEffect(() => {
    domain();
    // deptByDomainName();
    // ssoRoleByDomainName();
    ssoRoleBydeptId();
    // desigByDomainName();
    desigByDeptId();
  }, []);

  function domain() {
    dispatch({ type: loader.startLoader });
    domainList((res) => {
      dispatch({ type: loader.stopLoader });
      if (res.status) {
        // setPincodeListData(res.data.result);
        setDomainListArr(res?.data?.result);
        console.log(res);
      } else {
        console.log(res);
      }
    });
  }

  function deptByDomainName(domainCo) {
    deptBydomain(domainCo, (res) => {
      if (res.status) {
      } else {
      }
    });
  }
  function ssoRoleByDomainName(domainCo) {
    ssoRoleBydomain(domainCo, (res) => {
      if (res.status) {
      } else {
      }
    });
  }

  function ssoRoleBydeptId() {
    ssoRoleBydept("26", (res) => {
      if (res.status) {
      } else {
      }
    });
  }

  function desigByDomainName(domainCo) {
    desigByDomain(domainCo, (res) => {
      if (res.status) {
      } else {
      }
    });
  }

  function desigByDeptId() {
    desigByDept("54", (res) => {
      if (res.status) {
      } else {
      }
    });
  }

  const renderForm = () => {
    console.log("DOMAINCODE",domainCodeS)

    switch (domainCodeS) {
      case "CS":
        return <CitizensCentric/>;
      case "AA":
        return <Aawaas/>;
      case "BH":
        return <Bhoomi/>;
      case "MS":
        return <OnlineMeasurementEMB/>;
      case "WB":
        return <WaterBill/>;
      case "OP":
        return <Opd/>;
      case "ID":
        return <Idli/>;
      case "BO":
        return <OnlineBookingCommunity/>;
      case "LM":
        return <h1>LIMS !</h1>;
      case "NP":
        return <h1>New Payroll !</h1>;
      case "VL":
        return <h1>VLMS !</h1>;
      case "EW":
        return <h1>Expression of willingness !</h1>;
      default:
        return <h5>Please Select Any Domain!</h5>;
    }
  };

  return (
    <>
      <div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">
          <h4 className="h2_heading">Register Department User</h4>

          <div className="row justify-content-around ">
            <div className="col-12">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  Domain Name:
                </label>

                <select
                  class="form-control form-select"
                  onChange={(e) => {
                    setDomainCodeS(e.target.value);
                    desigByDomainName(e.target.value);
                    ssoRoleByDomainName(e.target.value);
                    deptByDomainName(e.target.value);
                  }}
                >
                  <option value="0">Select Domain </option>

                  {domainListArr.map((val) => {
                    return (
                      <option key={val} value={val.domainCode}>
                        {val.domainName}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>

          {/* <Aawaas/> */}
          {/* <OnlineMeasurementEMB/> */}
          {/* <CitizensCentric/> */}
          {/* <Idli/> */}
          {/* <WaterBill/> */}
          {/* <OnlineBookingCommunity/> */}

          {renderForm()}
        </div>
      </div>
    </>
  );
};
export default DeptMyProfile;
